export default __webpack_public_path__ + "static/media/excel.b559a7e0.png";